
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.584 15.021L12.52 2.034C11.384.123 8.617.12 7.481 2.034L.416 15.02c-1.16 1.953.244 4.426 2.519 4.426h14.13c2.272 0 3.68-2.471 2.52-4.426zM10 17.103a1.173 1.173 0 01-1.172-1.172c0-.646.526-1.172 1.172-1.172.646 0 1.172.526 1.172 1.172 0 .646-.526 1.172-1.172 1.172zm1.172-4.688c0 .646-.526 1.172-1.172 1.172a1.173 1.173 0 01-1.172-1.172V6.556c0-.646.526-1.172 1.172-1.172.646 0 1.172.526 1.172 1.172v5.86z"}})])
          )
        }
      }
    